/** The PCM live transcription expects: 16 kHz 16-bit mono in 100 ms frames. */
export const PCM_SAMPLE_RATE = 16000;
const FRAME_MS = 100;
export const PCM_FRAME_SAMPLES = (PCM_SAMPLE_RATE * FRAME_MS) / 1000;
export const PCM_WORKLET_NAME = 'pcm-downsampler';
